import TeamMembersTable from '../components/teamMembers/TeamMembersTable';
import Filters from '../components/filters/Filters';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { useTeamMembersTableStore } from '../store/myTeamTableStateStore';
import UsageTracker from '../../../utils/UsageTracker';
import { PAGE_NAMES } from '../../../constants/Navigation';
import { useEffect } from 'react';
import { HasGate } from '../../accounts/components/HasGate';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PageHeader } from '../../header/components/PageHeader';
import Card from '../components/common/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MyTeamMembers = () => {
  const store = useTeamMembersTableStore();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_MEMBERS
    });
  }, []);
  return /*#__PURE__*/_jsx(HasGate, {
    fallback: /*#__PURE__*/_jsxs(ListingPage, {
      headerComponent: null,
      children: [/*#__PURE__*/_jsx(Filters, {
        store: store
      }), /*#__PURE__*/_jsx(TeamMembersTable, {})]
    }),
    gate: "Academy:UnifiedAcademy:Navigation",
    children: /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(PageHeader, {
        subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingSubTitles.MY_TEAM_MEMBERS"
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingTitles.MY_TEAM_MEMBERS"
        })
      }), /*#__PURE__*/_jsxs(Card, {
        children: [/*#__PURE__*/_jsx(Filters, {
          store: store
        }), /*#__PURE__*/_jsx(TeamMembersTable, {})]
      })]
    })
  });
};
export default MyTeamMembers;